"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightboxElement = null;
var currentImages = [];
var currentIndex = 0;

function ensureLightboxExists() {
  var _lightboxElement$quer, _lightboxElement$quer2, _lightboxElement$quer3, _lightboxElement$quer4;

  if (lightboxElement && document.body.contains(lightboxElement)) {
    return lightboxElement;
  }

  lightboxElement = document.createElement('dialog');
  lightboxElement.className = 'image-lightbox';
  lightboxElement.innerHTML = "\n    <div class=\"lightbox-backdrop\">\n      <button type=\"button\" class=\"lightbox-close\" aria-label=\"Close\">\xD7</button>\n      <div class=\"lightbox-content\">\n        <button type=\"button\" class=\"lightbox-nav lightbox-prev\" aria-label=\"Previous\">\u2039</button>\n        <img src=\"\" alt=\"\" class=\"lightbox-image\" />\n        <button type=\"button\" class=\"lightbox-nav lightbox-next\" aria-label=\"Next\">\u203A</button>\n      </div>\n      <div class=\"lightbox-counter\"></div>\n    </div>\n  "; // Event listeners

  (_lightboxElement$quer = lightboxElement.querySelector('.lightbox-close')) === null || _lightboxElement$quer === void 0 ? void 0 : _lightboxElement$quer.addEventListener('click', close);
  (_lightboxElement$quer2 = lightboxElement.querySelector('.lightbox-prev')) === null || _lightboxElement$quer2 === void 0 ? void 0 : _lightboxElement$quer2.addEventListener('click', prev);
  (_lightboxElement$quer3 = lightboxElement.querySelector('.lightbox-next')) === null || _lightboxElement$quer3 === void 0 ? void 0 : _lightboxElement$quer3.addEventListener('click', next);
  (_lightboxElement$quer4 = lightboxElement.querySelector('.lightbox-backdrop')) === null || _lightboxElement$quer4 === void 0 ? void 0 : _lightboxElement$quer4.addEventListener('click', function (e) {
    if (e.target.classList.contains('lightbox-backdrop')) close();
  });
  lightboxElement.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });
  document.body.appendChild(lightboxElement);
  return lightboxElement;
}

function updateDisplay() {
  if (!lightboxElement) return;
  var img = lightboxElement.querySelector('.lightbox-image');
  var counter = lightboxElement.querySelector('.lightbox-counter');
  var prevBtn = lightboxElement.querySelector('.lightbox-prev');
  var nextBtn = lightboxElement.querySelector('.lightbox-next');
  if (img) img.src = currentImages[currentIndex] || '';
  if (counter) counter.textContent = "".concat(currentIndex + 1, " / ").concat(currentImages.length);
  var hasMultiple = currentImages.length > 1;
  if (prevBtn) prevBtn.style.display = hasMultiple ? '' : 'none';
  if (nextBtn) nextBtn.style.display = hasMultiple ? '' : 'none';
  if (counter) counter.style.display = hasMultiple ? '' : 'none';
}

function open(images) {
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  currentImages = images;
  currentIndex = startIndex;
  var dialog = ensureLightboxExists();
  updateDisplay();
  dialog.showModal();
}

function close() {
  var _lightboxElement;

  (_lightboxElement = lightboxElement) === null || _lightboxElement === void 0 ? void 0 : _lightboxElement.close();
}

function next() {
  if (currentImages.length === 0) return;
  currentIndex = (currentIndex + 1) % currentImages.length;
  updateDisplay();
}

function prev() {
  if (currentImages.length === 0) return;
  currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
  updateDisplay();
}
/**
 * Bind click handlers to images within an element.
 * Call this after rendering content with images.
 *
 * @example
 * ImageLightbox.bindTo(contentElement)
 */


function bindTo(element) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'img:not([src*="emojione"])';
  var images = element.querySelectorAll(selector);
  var srcs = Array.from(images).map(function (img) {
    return img.src;
  }).filter(Boolean);
  if (srcs.length === 0) return;
  images.forEach(function (img, index) {
    // Skip if already bound
    if (img.dataset.lightboxBound) return;
    img.dataset.lightboxBound = 'true';
    img.style.cursor = 'pointer';
    img.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open(srcs, index);
    });
  });
}

var ImageLightbox = {
  bindTo: bindTo,
  open: open,
  close: close
};
var _default = ImageLightbox;
exports.default = _default;